import { useTranslation } from "react-i18next";

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

import ExecutionsList from "./ExecutionsList";

interface Props {
  itemId: number;
  itemName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function ExecutionsSheet({
  itemId,
  itemName,
  open,
  onOpenChange,
}: Props) {
  const { t } = useTranslation();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-3xl">
        <SheetHeader>
          <SheetTitle>{t("items.detail.executions.sheetTitle")}</SheetTitle>
          <SheetDescription>{itemName}</SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-4 pb-4">
          <ExecutionsList itemId={itemId} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
